import React, { useEffect } from 'react';
import { X } from 'lucide-react';

const Modal = ({ isOpen, onClose, title, children, size = 'md', headerBorder = true }) => {
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const sizeClasses = {
    sm: 'max-w-md',
    md: 'max-w-lg',
    lg: 'max-w-2xl',
    xl: 'max-w-6xl',
    full: 'max-w-[98vw]'
  };

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      {/* Backdrop */}
      <div 
        className="fixed inset-0 bg-black/50 transition-opacity"
        onClick={onClose}
      />
      
      {/* Modal */}
      <div className="flex min-h-full items-center justify-center p-4">
        <div className={`relative bg-[color:var(--surface)] rounded-lg border border-[color:var(--border)] theme-shadow w-full ${sizeClasses[size]} transform transition-all`}>
          {/* Header */}
          <div className={`flex items-center justify-between p-6 ${headerBorder ? 'border-b border-[color:var(--border)]' : ''}`}>
            <h3 className="text-lg font-semibold text-[color:var(--text-primary)]">
              {title}
            </h3>
            <button
              onClick={onClose}
              className="text-[color:var(--text-muted)] hover:text-[color:var(--text-primary)] transition-colors"
            >
              <X className="h-5 w-5" />
            </button>
          </div>
          
          {/* Content */}
          <div className="p-6 text-[color:var(--text-primary)]">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
